/**
 * Transfer ActionTypes
 */
export enum Actions {
  UPDATE_TRANSFER_INPUT = "UPDATE_TRANSFER_INPUT",
  SET_TRANSFER_INPUT_DIRTY = "SET_TRANSFER_INPUT_DIRTY",
  SWITCH_TRANSFER_VALIDITY = "SWITCH_TRANSFER_VALIDITY",
  SET_TRANSFER_SUBSCRIPTION_ACCENDO_TOKEN = "SET_TRANSFER_SUBSCRIPTION_ACCENDO_TOKEN",
}



// WEBPACK FOOTER //
// ./src/containers/TransferSubscriptionAccendo/store/Actions.ts